import { NavItemProps } from "../types";

export const USER_NAVS: NavItemProps[] =  [{
  title: 'Akun Saya',
  position: "right",
  link: '#',
  childItems: [
    {
      title: "Pengajuan",
      link: "/accounts/applications",
      position: "right",
    },
    {
      title: "Polis Saya",
      link: "/accounts/policy",
      position: "right",
    },
    {
      title: "Profil",
      link: "/accounts/profile",
      position: "right",
    }, 
  ]
}];

export const LOGOUT_NAV: NavItemProps = {
  title: "Keluar",
  link: "",
  position: "right",
};